import moment from "moment-timezone";
import React, { FC } from "react";
import ReactSelect from "react-select";

type Props = {
  currentTimeZone: string;
  onChange: (timezone: string) => void;
  inputId?: string;
};

const TimeZoneSelector: FC<Props> = ({
  currentTimeZone,
  onChange,
  inputId,
}) => {
  const options = moment.tz
    .names()
    .map((zone) => ({ zone, offset: moment().tz(zone).utcOffset() }))
    .sort((a, b) => a.offset - b.offset || a.zone.localeCompare(b.zone))
    .map(({ zone }) => ({
      value: zone,
      label: "(UTC" + moment().tz(zone).format("Z") + ") " + zone,
    }));

  return (
    <ReactSelect
      inputId={inputId}
      className="w-full max-w-full min-w-0 py-1 bg-white text-gray-700"
      options={options}
      maxMenuHeight={250}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        menu: (base) => ({ ...base, width: "100%", overflowX: "hidden" }),
        option: (base) => ({
          ...base,
          whiteSpace: "normal",
          wordBreak: "break-word",
        }),
        singleValue: (base) => ({
          ...base,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }),
      }}
      value={
        currentTimeZone
          ? {
              value: moment.tz.names().find((item) => item === currentTimeZone),
              label:
                "(UTC" +
                moment().tz(currentTimeZone).format("Z") +
                ") " +
                currentTimeZone,
            }
          : {
              value: moment.tz
                .names()
                .find((item) => item === moment.tz.guess()),
              label:
                "(UTC" +
                moment().tz(moment.tz.guess()).format("Z") +
                ") " +
                moment.tz.guess(),
            }
      }
      onChange={(e) => {
        onChange(e?.value as string);
      }}
    />
  );
};

export default TimeZoneSelector;
